import { adaptRequestMultiItemFieldsToDict, adaptRequestSortAndFiltersToDict, adaptRequestToDict } from 'stores/adapters/bex-api/search/request-fields-adapter';
export const getDefaultRequestFields = (criteria, multiItemId, bexApiResults, multiItem) => {
  let multiItemFields = {};
  if (multiItem === null || multiItem === void 0 ? void 0 : multiItem.isPackageShoppingPath()) {
    multiItemFields = adaptRequestMultiItemFieldsToDict(multiItemId, bexApiResults);
  }
  return Object.assign(Object.assign(Object.assign({}, adaptRequestToDict(criteria)), adaptRequestSortAndFiltersToDict(criteria)), multiItemFields);
};